import { GenericButtonType } from '@/types/common/button'
import { ActionType } from './types'

export const GENERIC_HALFSHEET_BUTTONS = {
  PRIMARY_CLOSE: {
    labels: {
      ja: '閉じる',
      en: 'Close',
    },
    actionType: ActionType.Close,
    buttonType: GenericButtonType.PRIMARY,
  },
  PRIMARY_CLOSE_APP: {
    labels: {
      ja: '閉じる',
      en: 'Close',
    },
    actionType: ActionType.CloseApp,
    buttonType: GenericButtonType.PRIMARY, 
  }
}

export const DEFAULT_ERROR_DISPLAY_INFO = {
  backendResultCode: 'DEFAULT_ERROR',
  titles: {
    ja: '通信エラーが発生しました。',
    en: '通信エラーが発生しました。',
  },
  descriptions: {
    ja: '時間をおいて再度お試しください。',
    en: '時間をおいて再度お試しください。',
  },
  buttonList: [GENERIC_HALFSHEET_BUTTONS.PRIMARY_CLOSE],
}

export const NOTICE_TIMEOUT_ERROR_DISPLAY_INFO = {
  backendResultCode: 'NOTICE_TIMEOUT_ERROR',
  titles: {
    ja: 'エラーが発生しました',
    en: 'エラーが発生しました',
  },
  descriptions: {
    ja: 'しばらく時間をおいてから再度お試しください。',
    en: 'しばらく時間をおいてから再度お試しください。',
  },
  buttonList: [GENERIC_HALFSHEET_BUTTONS.PRIMARY_CLOSE],
}

export const TIMEOUT_ERROR_DISPLAY_INFO = {
  backendResultCode: 'TIMEOUT_ERROR',
  titles: {
    ja: 'タイムアウトしました',
    en: 'タイムアウトしました',
  },
  descriptions: {
    ja: 'PayPayホーム画面から\nポイント運用をタップしてください',
    en: 'PayPayホーム画面から\nポイント運用をタップしてください',
  },
  buttonList: [GENERIC_HALFSHEET_BUTTONS.PRIMARY_CLOSE_APP],
}

export const INVALID_CSRF_TOKEN_ERROR_DISPLAY_INFO = {
  backendResultCode: 'INVALID_CSRF_TOKEN_ERROR',
  titles: {
    ja: 'エラーが発生しました',
    en: 'エラーが発生しました',
  },
  descriptions: {
    ja: 'ポイント運用ミニアプリからアクセスしてください。',
    en: 'ポイント運用ミニアプリからアクセスしてください。',
  },
  buttonList: [GENERIC_HALFSHEET_BUTTONS.PRIMARY_CLOSE],
}

export const INVALID_ALL_PERIOD_ERROR_DISPLAY_INFO = {
  backendResultCode: 'INVALID_ALL_PERIOD_ERROR',
  titles: {
    ja: 'エラーが発生しました',
    en: 'エラーが発生しました',
  },
  descriptions: {
    ja: '一度ポイント運用を閉じてから再度お試しください。',
    en: '一度ポイント運用を閉じてから再度お試しください。',
  },
  buttonList: [GENERIC_HALFSHEET_BUTTONS.PRIMARY_CLOSE],
}

export const OUT_OF_BTC_TRADING_TIME_ERROR_DISPLAY_INFO = {
  backendResultCode: 'OUT_OF_BTC_TRADING_TIME_ERROR',
  titles: {
    ja: '注文受付時間外です',
    en: '注文受付時間外です',
  },
  descriptions: {
    ja: '以下の時間に再度お試しください\n<b>注文可能時間</b>\n月〜金 08:05〜翌06:55\n（米国夏時間：月〜金 07:05〜翌05:55）\n\n<span class="small-text">土日および弊社が定めた特定の日付は取引できません\n詳細は<a>取引カレンダー</a>をご確認ください</span>',
    en: '以下の時間に再度お試しください\n<b>注文可能時間</b>\n月〜金 08:05〜翌06:55\n（米国夏時間：月〜金 07:05〜翌05:55）\n\n<span class="small-text">土日および弊社が定めた特定の日付は取引できません\n詳細は<a>取引カレンダー</a>をご確認ください</span>',
  },
  buttonList: [GENERIC_HALFSHEET_BUTTONS.PRIMARY_CLOSE],
}
